import { Status, Wrapper } from "@googlemaps/react-wrapper";
import { Link, useParams } from 'react-router-dom';
import Map from './Map';
import { JournalEntry } from './models/JournalEntry';
import PhotoComponent from './PhotoComponent';
import Polyline from './Polyline';
import { useEffect, useState } from 'react'
import { TripConfig } from './TripConfig'

declare global {
  interface Window { cachedPhotos: any; }
}

function JournalEntryComponent() {
  const { journalId } = useParams();
  const [journalEntry, setJournalEntry] = useState<JournalEntry | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/journal-${journalId}.json`)
      .then(res => res.json())
      .then(data => {
        setJournalEntry(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to load journal entry:', err);
        setLoading(false);
      });
  }, [journalId]);

  const render = (status: Status) => {
    return <h1>{status}</h1>;
  };

  useEffect( () => {
    if (!loading && journalEntry) {
      const cacheImages = async() => {
        window.cachedPhotos = journalEntry.photos.map(photo => {
         const img = new Image().src = "/img/" + photo.name;
         return img;
        })
    }
    cacheImages()
    }
  },[loading, journalEntry])

  const regex = /\[photo:(\d+)\]/g;
  const isnum = /^\d+$/;
  
return (
    <div style={{ display: "flex", height: "100%" }}>
      { loading ?
        <div></div>
        :
        <div className='container'>
          <div>
          {journalEntry?.previousJournalEntryId !== undefined && journalEntry?.previousJournalEntryId > 0 ? (
          <Link
            to={`/journal/${journalEntry?.previousJournalEntryId}`}
            key={journalEntry?.previousJournalEntryId}
            style={{marginRight:"1rem"}}
          >
            Previous
          </Link>):<></>}
            <span>
            <b>{journalEntry?.startDate} {journalEntry?.startLocation} to {journalEntry?.endDate} {journalEntry?.endLocation}</b>
            </span>
          {journalEntry?.nextJournalEntryId !== undefined && journalEntry?.nextJournalEntryId > 0 ? (
            <Link
            to={`/journal/${journalEntry?.nextJournalEntryId}`}
            key={journalEntry?.nextJournalEntryId}
            style={{marginLeft:"1rem"}}
          >
            Next
          </Link>):<></>}
          </div>

          <div>
            {journalEntry?.text.split('<br><br>').map(text => {
              return[
            text.split(regex).map(t => t.match(isnum) ?
              <PhotoComponent photoId={journalEntry?.photos.find(photo=>photo.id === parseInt(t))?.id}
              photoName={journalEntry?.photos.find(photo=>photo.id === parseInt(t))?.name}
              photoCaption={journalEntry?.photos.find(photo=>photo.id === parseInt(t))?.caption}
              photoLocation={journalEntry?.photos.find(photo=>photo.id === parseInt(t))?.location}
              photoCountry={journalEntry?.photos.find(photo=>photo.id === parseInt(t))?.country}
              photoDate={journalEntry?.photos.find(photo=>photo.id === parseInt(t))?.date}
              />
            :
              <span dangerouslySetInnerHTML={{__html: t}}/>),
            <br/>,<br/>
              ]
            })
            }
          </div>
        <Wrapper apiKey={TripConfig.googleMapsApiKey} render={render}>
        <Map
          mapTypeId={'terrain'}
          center={journalEntry && journalEntry.mapCenter}
          zoom={journalEntry && journalEntry.mapZoomLevel}
          style={{ width: "100%", height: "600px" }}
        >
        {journalEntry && journalEntry.rides.map(ride =>
          ride.paths.map(path =>
            <Polyline
              strokeColor={path.pathType === "ride" ? "#656398" : "#BBBBBB"}
              strokeOpacity={.7}
              strokeWeight={6}
              path={path.coordinates}
               />
          )
         )
        }
       </Map>
      </Wrapper>
      </div>
      }
    </div>
  );
};

export default JournalEntryComponent;
